import React from 'react'
import {
    MutateVoyageRootContext
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/RootContextProviderMutateSingleVoyage";


export const useRootContextMutateSingleVoyage = () => React.useContext(MutateVoyageRootContext)